import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DcBadgeModule } from '@datachain/ui-sdk/components/app-badge';
import { DcButtonModule } from '@datachain/ui-sdk/components/app-button';
import { DcOverlayBadgeModule } from '@datachain/ui-sdk/components/app-overlay-badge';
import { DcPageModule } from '@datachain/ui-sdk/components/app-page';
import { DcPanelModule } from '@datachain/ui-sdk/components/app-panel';
import { DcPopoverModule } from '@datachain/ui-sdk/components/app-popover';
import { DcAvatarModule } from '@datachain/ui-sdk/components/avatar';
import { DcBreadcrumbModule } from '@datachain/ui-sdk/components/breadcrumb';
import { DcNavigateDirectiveModule } from '@datachain/ui-sdk/directives';
import { DcArrayPipeModule } from '@datachain/ui-sdk/pipes';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DxDataGridModule } from 'devextreme-angular';

import { MaterialModule } from '../ui/material.module';
import { UiModule } from '../ui/ui.module';
import { DashboardActionPopupComponent } from './components/dashboard-action-popup/dashboard-action-popup.component';
import { DashboardListComponent } from './components/dashboard-list/dashboard-list.component';
import { DashboardAdapter } from './dashboard.adapter';
import {
	DashboardEffects,
	DashboardFeatureKey,
	dashboardReducers,
	DashboardSelector,
} from './store';

@NgModule({
	declarations: [DashboardListComponent, DashboardActionPopupComponent],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		UiModule,
		MaterialModule,
		StoreModule.forFeature(DashboardFeatureKey, dashboardReducers),
		EffectsModule.forFeature([DashboardEffects]),
		DxDataGridModule,
		NgOptimizedImage,
		FormsModule,
		DcPageModule,
		DcPanelModule,
		DcArrayPipeModule,
		DcBadgeModule,
		DcAvatarModule,
		DcNavigateDirectiveModule,
		DcBreadcrumbModule,
		DcOverlayBadgeModule,
		DcPopoverModule,
		DcButtonModule,
	],
	providers: [DashboardAdapter, DashboardSelector],
})
export class DashboardModule {
	public constructor(private readonly injector: Injector) {
		const dashboardListCmpElement = createCustomElement(
			DashboardListComponent,
			{
				injector,
			}
		);
		customElements.define('app-dashboard-list', dashboardListCmpElement);
	}
}
